import { render } from "./SFormular.vue?vue&type=template&id=639130f4"
import script from "./SFormular.vue?vue&type=script&lang=js"
export * from "./SFormular.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__